// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Objectives_Objectives__CyNsW {
  max-width: 100%;
  margin: 2rem 0 4rem;

  .Objectives_section__24zLK {
    position: relative;
    width: 100%;
  }

  & img {
    display: block;
    height: auto;
  }

  & p {
    word-wrap: break-word;
    max-width: 90%;
    padding-left: 5px;
    position: absolute;
    bottom: 0;
    left: 0;
    font-family: Inter;
    font-size: 0.9rem;
    font-weight: 500;
    color: var(--text-color);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Objectives/Objectives.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,mBAAmB;;EAEnB;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,qBAAqB;IACrB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;EAC1B;AACF","sourcesContent":[".Objectives {\n  max-width: 100%;\n  margin: 2rem 0 4rem;\n\n  .section {\n    position: relative;\n    width: 100%;\n  }\n\n  & img {\n    display: block;\n    height: auto;\n  }\n\n  & p {\n    word-wrap: break-word;\n    max-width: 90%;\n    padding-left: 5px;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    font-family: Inter;\n    font-size: 0.9rem;\n    font-weight: 500;\n    color: var(--text-color);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Objectives": `Objectives_Objectives__CyNsW`,
	"section": `Objectives_section__24zLK`
};
export default ___CSS_LOADER_EXPORT___;
